// 占位数据:欢迎页项目选择 chip 使用的示例项目列表。
// ⚠️ 这是假数据,仅用于视觉占位,未接入真实项目 API(见 Issue #30)。
// #30 接入真实项目选择时应删除本文件,改用真实 projects 事实源 + 会话归属 API。
// 名称刻意使用通用示例名,避免与 demo-parity 中"需隐藏的真实项目名"冲突。
export type PlaceholderProject = {
  id: string;
  name: string;
};

export const placeholderProjects: PlaceholderProject[] = [
  { id: "sample-a", name: "示例项目 A" },
  { id: "sample-b", name: "示例项目 B" },
  { id: "sample-c", name: "示例项目 C" }
];
